import { useState } from "react";

import IconButton from "@material-ui/core/IconButton";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";

import { ConfirmDialog, DeleteButton } from "../../components";
import { MUTATIONS } from "../../../graphql";
import { Service } from "../../../graphql/models";
import { useSnackbarMutation } from "../../../hooks";

export interface ServiceDeleteRestoreButtonProps {
  service: Service;
  onDone: () => void;
}

/**
 * Delete / restore button for a service (System Admin only: the caller is
 * responsible for rendering it only when `isAdminUser` is true).
 * Shows a delete button when the service is active and a restore button when
 * the service is deleted. Both ask for confirmation.
 */
export function ServiceDeleteRestoreButton(
  props: ServiceDeleteRestoreButtonProps
) {
  const { service, onDone } = props;
  const isDeleted = service.deleted === true;

  const [open, setOpen] = useState(false);
  const [invokeMutation, { loading }] = useSnackbarMutation(
    isDeleted ? MUTATIONS.RESTORE_SERVICE : MUTATIONS.DELETE_SERVICE,
    { onCompleted: () => onDone() }
  );

  const confirm = () => {
    invokeMutation({ variables: { id: service.id } });
  };

  return (
    <>
      {isDeleted ? (
        <IconButton
          aria-label="restore"
          size="medium"
          title="Ripristina servizio"
          onClick={() => setOpen(true)}
        >
          <RestoreFromTrashIcon fontSize="inherit" />
        </IconButton>
      ) : (
        <DeleteButton
          title="Elimina servizio"
          onClick={() => setOpen(true)}
        />
      )}
      <ConfirmDialog
        open={open}
        setOpen={setOpen}
        onConfirm={confirm}
        onUndo={() => setOpen(false)}
        dialogProps={{
          title: isDeleted ? "Conferma ripristino servizio" : "Conferma eliminazione servizio",
          fullScreen: false,
        }}
        actionsDisabled={loading}
      >
        {isDeleted
          ? `Confermi di voler ripristinare il servizio "${service.name}"? Tornerà visibile nelle liste, nelle tendine, nella sidebar e nell'app, e sarà di nuovo prenotabile.`
          : `Confermi di voler eliminare il servizio "${service.name}"? Sparirà dalle liste, dalle tendine, dalla sidebar e dall'app e non sarà più prenotabile. Le prenotazioni già esistenti restano.`}
      </ConfirmDialog>
    </>
  );
}
